<script lang="ts">
    import { Col} from "sveltestrap";
    import data from "../../../../Data/Chat/Chat.json"
    import ChatTabContent from "./ChatTabContent.svelte";
    import {tabOpen} from "../../../../store"
    let open:boolean = false
    let selectId:string ="info-home-tab"
    const handleTab =(id:string) =>{
        selectId = id
        if(selectId === id){
            open = true
        }
    }
    let setTabOpen:boolean
    tabOpen.subscribe((value)=>{
        setTabOpen = value
    })
</script>
{#if setTabOpen}
    <Col class='chat-menu show'>
        <ul class="nav nav-tabs border-tab nav-primary" id="info-tab" role="tablist">
            {#each data.chatmenudata as chatItem}
            <li class="nav-item">
                <!-- svelte-ignore a11y-click-events-have-key-events -->
                <a class="nav-link {selectId === chatItem.id && open ? "active" : ""}" id={chatItem.id} on:click={()=>handleTab(chatItem.id)}>{chatItem.title}</a>
                <div class="material-border"></div>
            </li>
            {/each}
        </ul>
        <ChatTabContent getId={selectId}/>
    </Col>
{/if}